<input
    #input
    mdbInput
    [attr.readonly]="readonly ? '': null"
    [formControl]="control"
    [mdbAutocomplete]="autocompleteName"
    maxlength="128"
    type="text"
    id="autocompleteName"
    class="form-control form-control--paybee"
/>
<label #label mdbLabel class="form-label form-label--paybee" for="autocompleteName">Address</label>
@if(control.hasError('required') && control.touched) {
    <span class="form-fill-error--p2p ml-0">Please provide Address</span>
}
<button *ngIf="addressObject" [ngClass]="{'disabled': readonly}" class="appGoogleMapsAutocomplete-clear" (click)="onClearAddress()" matSuffix [attr.aria-label]="'Clear'">
    <i class="fas fa-times"></i>
</button>
<mdb-autocomplete #autocompleteName="mdbAutocomplete" [displayValue]="displayValue">
    @for(option of result; track option.data.id) {
        <mdb-option [value]="option">
            {{ option.searchString }}
        </mdb-option>
    }
    @if(notFound) {
        <div class="autocomplete-no-results d-none">No Results Found</div>
    }
</mdb-autocomplete>